var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 4.67122H8.66659V6.00456H7.33325V4.67122ZM7.33325 7.33789H8.66659V11.3379H7.33325V7.33789ZM7.99992 1.33789C4.31992 1.33789 1.33325 4.32456 1.33325 8.00456C1.33325 11.6846 4.31992 14.6712 7.99992 14.6712C11.6799 14.6712 14.6666 11.6846 14.6666 8.00456C14.6666 4.32456 11.6799 1.33789 7.99992 1.33789ZM7.99992 13.3379C5.05992 13.3379 2.66659 10.9446 2.66659 8.00456C2.66659 5.06456 5.05992 2.67122 7.99992 2.67122C10.9399 2.67122 13.3333 5.06456 13.3333 8.00456C13.3333 10.9446 10.9399 13.3379 7.99992 13.3379Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.35953cca.svg";
export { ForwardRef as ReactComponent };